import { lazy } from 'react';
import withSuspense from '../../../helpers/withSuspense';
import SkeletonComponent from '../../../skeleton_loaders/common/SkeletonComponent.jsx';
import ButtonSkeleton from '../../../skeleton_loaders/common/ButtonSkeleton.jsx';

const RepeatableImageUploader = withSuspense(lazy(() => import('./RepeatableImageUploader.jsx')), () => {
  return (
    <div style={{display: 'flex', flexDirection: 'row', gap: '1rem'}}>
      <SkeletonComponent width={50} height={45} />
      <div style={{display: 'flex', flexDirection: 'column', height: 50}}>
        <ButtonSkeleton />
        <SkeletonComponent width={150} />
      </div>
    </div>
    )
  }
)

export default RepeatableImageUploader;

